const campaignRequest: Record<string, Record<string, string> | string> = {
    registryTitle: 'Предоставленные сведения',
    RequestN: 'Форма № {number}',
    regFormCard: {
        registrationStartDate: 'Начало подачи',
        registrationEndDate: 'Окончание подачи',
    },
    createRequest: 'Подать сведения',
    regFormsPageTitle: 'Выбор формы подачи сведений',
    registryColumns: {
        campaign: 'Сбор сведений',
        number: 'Номер формы',
        regForm: 'Форма',
    },
    deleteRequest: 'Удалить',
    registryPagingInfo:
        'Всего {count, number} фор{count, plural, one {ма} few {мы} other {м}}. ' +
        'Отображены c {from, number} по {to, number}',
    registryPagingInfoIfNull: 'Всего 0 форм. Отображено 0 форм',
    printFormsTable: {
        crcCode: 'CRC-код',
    },
    errorTextForRequest:
        'Проверьте заполненность обязательных полей заявки и корректность введенных значений. Разделы, в которых содержатся ошибки, отмечены красным восклицательным знаком справа от анкеты заявки',
    readonlyRequestValidationMsg:
        'Форма заполнена некорректно. Для исправления ошибок перейдите к <a>редактированию</a>.',
    dialog: {
        leaveMessage: 'Вы действительно хотите покинуть текущую форму без сохранения изменений?',
    }
};

export default campaignRequest;
